import React, { useState, useEffect } from 'react';
//import left_img from '../images/left_side_caladine.png';
//import right_img from '../images/right_side_caladine.png';


let loadPage = true;




function Info() {

   
    useEffect(() => {
        if (loadPage) {
            //Chart();
        }
        return () => {
            loadPage = false
        };
    }, []);

    return (
        <div class="max-w-full mx-auto bg-white pt-4"><br /><br /><br /><br /><br />
            <div class="max-w-screen-xl mx-auto">
                <div class="grid grid-cols-2 gap-8">
                    <div>
                        <img src="https://bo.jdih.magelangkota.go.id/homep1.jpeg" alt="Mobile JDIH∂" class="rounded-xl h-[380px]" />
                    </div>

                    <div>
                        <img src="https://bo.jdih.magelangkota.go.id/homep2.jpeg" alt="Mobile JDIH∂" class="rounded-xl h-[380px]" />
                    </div>
                </div>
            </div><br />
        </div>
    );
}

export default Info;
